<template>
  <div
    id="ironpage"
    class="ironpage"
  >
    <el-header>
      <el-row align="middle">
        <el-col :span="6">
          <span v-if="!isok" @click="goBack" style="float: left;cursor: pointer;">< Back</span>
          <span>Xinhua-China Iron Ore Price Index</span>
        </el-col>
        <el-col
          :span="10"
          :offset="4"
        >
          Time frame
          <el-date-picker
            v-model="dateVal"
            type="daterange"
            @change="submit"
            @blur="submit"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
          />
        </el-col>
        <el-col :span="4">
          <!-- <el-button
            :loading="downloadLoading"
            class="filter-item"
            icon="el-icon-download"
            @click="handleDownload"
          >
            导出Excel</el-button> -->
          <!-- <div class="export">
            <span class="icon"></span>
            <span class="text">export</span>
            <div class="daochu">
              <div
                @click="exportData('table')"
                style="width:100px;"
              >export Excel</div>
              <div
                @click="exportData('chart')"
                style="width:100px;"
              >export png</div>
            </div>
          </div> -->
        </el-col>
      </el-row>
    </el-header>
    <div class="img">
      <!--图形-->
      <div
        ref='lineChart'
        id="lineChart"
        style="height:calc(100% - -7px);"
      ></div>
      <div
        class='nodata'
        v-show="nodata"
      >提取时间段内无数据</div>
    </div>
    <div class="table" id="full_table">
      <el-table :data="tableData">
        <el-table-column
          label="Date"
          prop="col1"
          width="80"
          :header-cell-style="{background:'#F5F7FA;'}"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tableHeader"
          :key="index"
          :label="item"
          :prop="item"
          min-width="100"
        >
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import echarts from 'echarts' //引入echarts
import { get_iron_price } from "common/js/http/v3Api";
export default {
  props: {
    isok: Boolean
  },
  data() {
    return {
      nodata: false,
      start_date: Number(new Date().getFullYear() - 3) + '-' + ((new Date().getMonth() + 1) >= 10 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)) + '-' + (new Date().getDate() >= 10 ? new Date().getDate() : '0' + new Date().getDate()),
      end_date: new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) >= 10 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)) + '-' + (new Date().getDate() >= 10 ? new Date().getDate() : '0' + new Date().getDate()),
      dateVal: '',
      downloadLoading: false,
      showData: {},
      ironData: {},
      tableHeader: [],
      tableData: [],
      chart: null,
      chartDate: {
        title: "Xinhua iron ore price index",
        legend: ['58% Fe Iron ore', '62% Fe Iron ore'],
        selected: { '58% Fe Iron ore': true, '62% Fe Iron ore': true },
        xDate: [],
        yName: [{ type: 'value', name: 'index', scale: true }],
        serData: []
      },
      serData: []
    }
  },
  mounted: function() {
    //this.draw()
    this.dateVal = [this.start_date, this.end_date]
    this.getDataList()
  },
  methods: {
    goBack() {
      this.$router.push("/ChinaInformationV2/1");
    },
    handleDownload() {

    },
    submit(time) {
      this.start_date = time[0] || time.value[0];
      this.end_date = time[1] || time.value[1];
      this.getDataList()
    },

    formatData(reqData) {
    },
    async getDataList() {
      const { data } = await get_iron_price({
        startTime: this.start_date,
        endTime: this.end_date
      });
      this.tableData = [];
      this.tableHeader = [];
      if (data != null && data.length !== 0) {
        const tmpData = data
        let tmpRow58 = { col1: "58%" }
        let tmpRow62 = { col1: "62%" }
        let chartSerData58 = []
        let chartSerData62 = []
        tmpData.map((item, index) => {
          this.tableHeader.push(item.DATA_TIME.substr(0, 10))
          tmpRow58[item.DATA_TIME.substr(0, 10)] = item.IRON_ORE_58_I
          tmpRow62[item.DATA_TIME.substr(0, 10)] = item.IRON_ORE_62_I
          chartSerData58.push(item.IRON_ORE_58_I)
          chartSerData62.push(item.IRON_ORE_62_I)
        })
        this.tableData.push(tmpRow58)
        this.tableData.push(tmpRow62)
        this.serData = [{
          name: '58% Fe Iron ore',
          type: 'line',
          stack: 'Total',
          data: chartSerData58
        }, {
          name: '62% Fe Iron ore',
          type: 'line',
          stack: 'Total',
          data: chartSerData62
        }]
      }
      this.draw()
    },
    draw() {
      let option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          top: "top",
          left: "left",
          data: ['58% Fe Iron ore', '62% Fe Iron ore']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.tableHeader
        },
        yAxis: {
          type: 'value'
        },
        series: this.serData
      };
      this.chart = echarts.init(document.getElementById("lineChart"));
      this.chart.setOption(option);
    },
    exportData(param) {
      if (param === "table") {
        var data = "";
        var title = this.saleData.title;
        if (this.showData.data.length === 0) {
          data = data + "\n" + "数据来源：新华财经终端"
          var params = {
            value: data,
            filename: title
          };
          this.exportTableData(params);
          return false
        } else {
          data = this.getExportDat($(this.showData.webTableId), "|");
          data = data + "\n" + "数据来源：新华财经终端"
          var params = {
            value: data,
            filename: title
          };

          this.exportTableData(params);
        }
      } else if (param === "chart") {

        var id = this.showData.webTableId;

        let titleName = '';
        let chart = '';
        debugger
        if (id === "newPage003001003Table" || id === "newPage003001004Table") {
          // console.log(this.$parent.$children[2].titleName);
          titleName = this.$parent.$children[2].titleName.split('.').join("");
          chart = this.$parent.$children[2].chart;
        } else {
          // console.log("1", this.$parent.$children[1]);
          titleName = this.$parent.$children[1].titleName.split('.').join("");
          chart = this.$parent.$children[1].chart;
        }
        let dataUrl = chart.getDataURL({ type: 'png' });
        this.exportImgData({ value: dataUrl, filename: titleName });
      }
    },
    exportTableData(params) {
      var interfaceUrl = "/Macromonitor/index.php/Macroeconomic_data/export?token=84ddfb34126fc3a48ee38d7044e87276";
      if ($("form")) {
        $("form").remove()
      }
      var form = document.createElement("form");
      $(document.body).append(form);
      form.action = HOST121 + interfaceUrl;
      form.method = "post";
      form.style.display = "none";
      var content = document.createElement("textarea");
      content.name = "content";
      content.value = params.value;
      var filename = document.createElement("textarea");
      filename.name = "filename";
      filename.value = params.filename;
      form.appendChild(content);
      form.appendChild(filename);
      document.body.appendChild(form);
      form.submit();
    },
    //导出图片数据
    exportImgData(params) {
      var interfaceUrl = "/Macromonitor/index.php/Macroeconomic_data/exportImgByBase64";
      if ($("form")) {
        $("form").remove()
      }
      var form = document.createElement("form");
      $(document.body).append(form);
      form.action = HOST121 + interfaceUrl;
      form.method = "post";
      form.style.display = "none";
      var imageData = document.createElement("textarea");
      imageData.name = "image";
      imageData.value = params.value;
      var filename = document.createElement("textarea");
      filename.name = "filename";
      filename.value = params.filename;
      form.appendChild(imageData);
      form.appendChild(filename);
      document.body.appendChild(form);
      form.submit();
    },
    getExportDat(view, split) {
      var options = {
        filterHTML: true,
        gB: "excel"
      };
      var scheme = this.getExportScheme(view, options);
      var filterHTML = !!options.filterHTML;
      var htmlFilter = /<[^>]*>/gi;
      var data = [];
      var header, headers;
      if (options.header !== false && scheme.length && options.gB === "excel") {
        for (var h = 0; h < scheme[0].header.length; h++) {
          headers = [];
          for (var i = 0; i < scheme.length; i++) {
            header = "";
            if (scheme[i].header[h])
              header = scheme[i].header[h];
            if (filterHTML)
              header = header.replace(htmlFilter, "");
            headers.push(header);
          }
          data.push(headers);
        }
      }

      var isTree = (view.data.name === "TreeStore");

      view.data.each(function(item) {
        if (item) { //dyn loading
          var line = [];
          for (var i = 0; i < scheme.length; i++) {
            var column = scheme[i];
            var cell = column.template(item, view.type, item[column.id], column, i);
            if (!cell && cell !== 0) cell = "";
            if (filterHTML && typeof cell === "string") {
              if (isTree)
                cell = cell.replace(/<div class=.webix_tree_none.><\/div>/, " - ");
              cell = cell.replace(htmlFilter, "");
            }
            line.push(cell);
          }
          data.push(line);
        }
      }, view);


      if (options.footer !== false) {
        var f_count = scheme[0].footer ? scheme[0].footer.length : 0;
        for (var f = 0; f < f_count; f++) {
          var footers = [];
          for (var i = 0; i < scheme.length; i++) {
            var footer = scheme[i].footer[f];
            if (filterHTML) footer = footer.replace(htmlFilter, "");
            footers.push(footer);
          }
          if (options._export_mode === "excel") data.push(footers);
        }
      }

      var strData = "";
      $.each(data, function(i, o) {
        if (split) {
          strData += o.c_toString(split) + "\r\n";
        } else {
          strData += o.toString() + "\r\n";
        }

      });
      return strData;
    },
    getExportScheme(view, options) {
      var scheme = [];
      var h_count = 0, f_count = 0;
      var isTable = view.getColumnConfig;
      var columns = options.columns;
      var raw = !!options.rawValues;
      var columns_pull = {};
      if (!columns) {
        if (isTable) {
          view.eachColumn(
            function(columnId) {
              var o = view.getColumnConfig(columnId);
              columns_pull[o.id] = o;
            }
          );
          columns = columns_pull;
        }
        else {
          columns = webix.copy(view.data.pull[view.data.order[0]]);
          for (var key in columns) columns[key] = true;
          delete columns.id;
        }
      }

      if (options.id)
        scheme.push({
          id: "id", width: 50, header: " ", template: function(obj) {
            return obj.id;
          }
        });

      for (var key in columns) {
        var column = columns[key];
        if (column.noExport) continue;

        if (isTable && columns_pull[key])
          column = webix.extend(webix.extend({}, column), columns_pull[key]);

        var record = {
          id: column.id,
          template: ((raw ? null : column.template) || function(key) {
            return function(obj) {
              return obj[key];
            };
          }(key)),
          width: ((column.width || 200) * (options._export_mode === "excel" ? 8.43 / 70 : 1)),
          header: (column.header !== false ? (column.header || key) : "")
        };

        if (typeof record.header === "string") record.header = [{ text: record.header }];
        else record.header = webix.copy(record.header);

        for (var i = 0; i < record.header.length; i++) {
          record.header[i] = record.header[i] ? (record.header[i].contentId ? "" : record.header[i].text) : "";
        }
        h_count = Math.max(h_count, record.header.length);
        scheme.push(record);
      }

      for (var i = 0; i < scheme.length; i++) {

        var diff = h_count - scheme[i].header.length;
        for (var d = 0; d < diff; d++)
          scheme[i].header.push("");

      }

      return scheme;
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#full_table ::-webkit-scrollbar,
#full_table ::-webkit-scrollbar {
  display: block;
}
.ironpage {
  /* // color: #fff; */
  margin-left: 10px;
  margin-right: 10px;
  background-color: #ffffff;

  width: calc(100% - 20px);
  height: 87vh;
}
  
.ironpage .title {
  height: 45px;
  width: 100%;
  /* //  border: 1px solid red;
  //  box-sizing: border-box; */
}
.ironpage .img {
    height: calc(100% - 45px - 52px - 110px - 30px);
    width: 100%;

    /* //  border: 1px solid #3f444f; */
    box-sizing: border-box;
    margin-top: 10px;
    position: relative;
    
}
.ironpage .img .nodata {
    position: absolute;
    top: 0;
    left: 0;
    /* //   background: #1e2131; */
    width: 100%;
    height: 100%;
    z-index: 9;
  }
.ironpage .table {
  height: calc(100% - 387px);
  width: 100%;
  /* // border: 1px solid #3f444f;
  // box-sizing: border-box; */
  margin-top: 10px;
  padding: 0 10px;
}
.el-header {
  border: 1px solid #eee;
  text-align: center;
  line-height: 60px;
  height: 60px;
  margin-bottom: 10px;
  background-color: #ffffff;
}
.export {
  position: relative;
  cursor: pointer;
  margin-left: 16px;
}
.export .daochu {
    cursor: pointer;
    position: absolute;
    top: 28px;
    left: 0;
    z-index: 10;
    width: 70px;
    height: 68px;
    visibility: hidden;
  }
.export .daochu div {
    line-height: 22px;
    height: 22px;
    color: #999;
  }
.export .icon {
  width: 14px;
  height: 15px;
  display: inline-block;
  position: relative;
  top: 3px;
  left: -5px;
  background-repeat: no-repeat;
  background-image: url("./assets/white_theme/export.png");
}
.export .daochu div:hover {
  color: rgb(64, 158, 255);
}
.export:hover .daochu {
  visibility: visible;
}
/* @import "./style/views/newPageBace.scss"; */
</style>
